{
    "position": [
      "Buy",
      "Sell"
    ],
    "productType": [
        "Vanilla Option",
        "European KI",
        "Digital"
      ],
      "optionType": [
          "Call",
          "Put"
      ]    
  }
  